import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService, TiposCalculos, TiposCreditos } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { ComercializacionService } from "../../../services/creditos/comercializacion.service";
import { ConveniosService } from '../../../services/convenios.service';

@Component({
    selector: 'comercial-simulador',
    templateUrl: './comercial-simulador.component.html'
  })

export class ComercialSimuladorComponent implements OnInit {
    //Constants
    private tipoCredito = TiposCreditos.MesesSinIntereses;
    //UI
    public cliente : any = {};
    public prestamo : any = {};
    public creditoMeses : any = {};
    public errors : any = {};
    public catalogoPeriodicidad : any = [];
    public plazos : any [] = [];
    public plazoSelected : any = '';
    //Subscriptions
    private sub: any;
    //Edit mode
    private id : number = null;
    //Selección de convenio
    public convenioDefault = "";
    public convenioSelected:any = {id:null};
    public optConvenios = []

    constructor(
      private helperService: HelpersService,
      public location: Location,
      private activeRoute: ActivatedRoute,
      private router: Router,
      private creditosService: CreditosService,
      private mesesService: ComercializacionService,
      private conveniosService : ConveniosService
    ){
    }

    public ngOnInit() {
        this.setDefaultValues();
        this.getConvenios();
        //Fill lista de plazos
        this.helperService.getPlazos(this.tipoCredito,
          (response)=>
        {
          this.plazos = response.json().content;
        });

        this.sub = this.activeRoute.params.subscribe(params => {
          if(params['id']){
              //Edit mode
              this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
              this.getCredito(this.id);
          } 
      });
    }

    public getConvenios(){
      // let filters = this.getActiveFilters();
  
      this.conveniosService.getAll({tipo:"Comercialización"}).subscribe(
        (response)=>
        {
          let respuesta = response.json().content;
          console.log(respuesta);
          if (respuesta.length > 1){
            this.optConvenios = respuesta;
            this.convenioDefault = "Sin convenio";
          }else{
            this.optConvenios = respuesta;
            this.convenioDefault = "Sin convenio";
            this.prestamo.idConvenio = null;
          }
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }
  
    convenioChanged(tipo){
      console.log("Event convenio: ", tipo);
      
      if(tipo.id){
          this.convenioSelected = tipo;
          // this.convenio.tipo_convenio = this.tipoSelected.nombre;
          // console.log("Tipo convenio: ",this.automotriz);
          // this.prestamos.calculo = this.convenioSelected.calculo;
          this.prestamo.periodicidad = this.convenioSelected.periodicidad;
          this.prestamo.idConvenio = this.convenioSelected.id;
      }else{
        this.setDefaultValues();
      }
    }
    private selectConvenio(tipo){
      this.convenioSelected = this.optConvenios[0];
      // this.convenio.tipo_convenio = this.tipoSelected;
      for (let index = 0; index < this.optConvenios.length; index++) {
        const element = this.optConvenios[index];
        if(element.nombre === tipo){
          this.convenioSelected = this.optConvenios[index];
          // this.convenio.tipo_convenio = tipo;
          break;
        }
        
      }
    }

    private setDefaultValues(){
        this.prestamo.calculo = TiposCalculos.MesesSinIntereses;
        this.prestamo.periodicidad = 2;//Periodicidad Mensual
        this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
    }

    private getCredito(idCredito : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.mesesService.get(idCredito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.prestamo = result.credito.prestamo;
          this.cliente = result.credito.cliente;
          this.creditoMeses = result.meses;
          this.plazoSelected = this.helperService.getSelectedPlazo(result.credito.prestamo, this.plazos);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
        this.errors = {};
        
        let credito = {
          idCreditos : null,
          prestamo : this.prestamo,
          cliente : null,
          meses : this.creditoMeses
        };
        
        //Obtener la información del cliente del crédito
        credito.cliente = this.getCliente();
  
        //El plazo seleccionado esta en el modelo plazoSelected, se debe actualizar el valor en el modelo que se enviará al servicio
        if(this.plazoSelected){
          //Default solo para pruebas
          credito.prestamo.plazo_periodo = this.plazoSelected.periodo;
          credito.prestamo.plazo_medida = this.plazoSelected.medida;
        }
  
        this.errors = this.mesesService.validate(credito);
        if (Object.entries(this.errors).length > 0) {
          return false;
        }
        if(this.id){
          //Update credito
          //set idCreditos
          credito.idCreditos = this.id;
          this.update(credito);
        }else{
          //New credito
          this.create(credito);
        }
    }

    private create(credito : any){
        this.mesesService.save(credito).subscribe(
          (response)=>
          {
            const result = response.json().content;
            //Navigate to tabla de amortizacion
            this.router.navigate(['/creditos/tabla-amortizacion/', result.id]);
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
              this.helperService.showSaveCreditErrors(error.json().content, this.errors);
            }
          }
        );
    }

    private update(credito : any){
      this.mesesService.update(credito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          //Navigate to tabla de amortizacion
          this.router.navigate(['/creditos/tabla-amortizacion/', this.id]);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.helperService.showSaveCreditErrors(error.json().content, this.errors);
          }
        }
      );
    }

    private getCliente(){
        let cliente = null;
        let clienteActual = this.cliente;

        if(typeof clienteActual.email === 'object'){
            //Cuando se selecciono un usuario con Typeahead, 
            //el modelo cliente.email tiene asociado un objeto con todos los datos del cliente
            let clienteToSave = {
                email : clienteActual.email.email,
                nombre : clienteActual.nombre,
                //Cuando es un update el modelo this.cliente tiene todos los datos del cliente
                //En el caso del create en el modelo this.cliente.email Typeahead pone el JSON completo del Cliente
                id : (clienteActual.id ? clienteActual.id : clienteActual.email.id)
            };
            cliente = clienteToSave;
        }else{
            //Caso cuando el email se ingreso de forma manual
            cliente = clienteActual;
        }
        
        return cliente;
    }

    public calculateMontoSolicitado(){
      if(this.creditoMeses.precio_venta){
        let montoPrestamo = this.creditoMeses.precio_venta;

        if(this.creditoMeses.enganche){
          montoPrestamo = montoPrestamo - this.creditoMeses.enganche;
        }
        
        this.prestamo.monto_prestamo = montoPrestamo;
      }
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/comercializacion/simulador/comercial-simulador.component.ts